import React from 'react';

interface ServiceCheckboxProps {
  name: string;
  label: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const ServiceCheckbox: React.FC<ServiceCheckboxProps> = ({
  name,
  label,
  checked,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="form__checkbox__option mb_16">
      <input
        type="checkbox"
        name={name}
        id={name}
        checked={checked}
        onChange={onChange}
        className="form__checkbox__input"
        disabled={disabled}
      />
      <label className="form__checkbox__label" style={{fontSize: "1.1rem"}} htmlFor={name} >
        {label}
      </label>
    </div>
  );
};

export default ServiceCheckbox;
